import React from 'react';

export class ContentHeadCompact extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <section className="content-head-compact">
        <h1 className="content-head-compact__left">{this.props.children}</h1>
        <div className="content-head-compact__right">{/* this.props.breadcrumb */}</div>
      </section>
    );
  }
}
